import { ChangeDetectorRef, Component } from '@angular/core';
import { HeaderService } from '../../services/header/header.service';
import { EnvironmentService } from '../../services/enviroment/environment.service';
import { StateHandlerService } from '../../services/state-handler/state-handler.service';
import { ParticipantsService } from '../../services/participants/participants.service';
import { TooltipSupportService } from '../../services/tooltip-support/tooltip-support.service';
import { Subject, takeUntil } from 'rxjs';
import { NgClass } from '@angular/common';
import { SupportTooltipComponent } from '../../components/support-tooltip/support-tooltip.component';

@Component({
  selector: 'sas-header',
  standalone: true,
  imports: [NgClass, SupportTooltipComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  public participants: number = 1;
  public showTooltip = false;
  public showIconUser = false;
  public showInviteForm = false;
  features: any;
  recording = false;

  supportPhone: string;

  /**
   * Subject para el unsubscribe de los observables al destriur el componente.
   */
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private readonly headerSvc: HeaderService,
    private readonly enviromentSvc: EnvironmentService,
    private readonly stateHandlerSvc: StateHandlerService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly participantsSvc: ParticipantsService,
    private readonly tooltipSupportService: TooltipSupportService
  ) {
    this.features = this.enviromentSvc.data.features;
    this.supportPhone = this.enviromentSvc.data.tech_support_phone;
  }

  /**
   * Inicializamos el componente.
   */
  ngAfterViewInit(): void {
    this.initHeader();
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Inicializa el número de participantes.
   * Obtiene el estado de la grabación.
   */
  async ngOnInit() {
    this.stateHandlerSvc.get('participants_number').subscribe((response: number) => {
      this.participants = response;
      this.changeDetectorRef.detectChanges();
    });
    this.stateHandlerSvc.get('record_state').subscribe((data) => {
      if (data) {
        this.recording = data.state;
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  /**
   * Obtenemos informaciónn, sobre el estado de la conexión
   * para mostrar la ifnormación del usuario.
   */
  public subscribeToStatusConection() {
    this.headerSvc.getStateConection().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (status: boolean) => {
        if (typeof status === 'boolean') {
          this.showIconUser = status;
        }
        this.changeDetectorRef.detectChanges();
      }
    );
  }

  /**
   * Método que abre el userListTooltip.
   */
  public showUserList() {
    this.showTooltip = !this.participantsSvc.showTooltipListUser;
    this.participantsSvc.setCloseOpenUserList(this.showTooltip);
  }

    /**
     * Método que abre el supportNumberTooltip.
     */
  public showSupportNumber() {
    this.tooltipSupportService.setCloseOpenTooltipSupport(true);
    this.changeDetectorRef.detectChanges();
  }


  /**
   * Método que inicializa el header y suscribe al nuevo usuario conectado.
   */
  private initHeader() {
    this.subscribeToStatusConection();
  }

  /**
   * Se desuscribe a los observables al destruitr el componente.
   */
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
